import { BarChartOutlined, DatabaseOutlined, ExperimentOutlined } from '@ant-design/icons';
import React from 'react';

// 9月份不做使用记录相关功能
export default {
    path: '/usage-record',
    code: 'UsageRecord',
    name: '资源用量',
    icon: <BarChartOutlined />,
    routes: [
      {
        path: '/usage-record',
        hideInMenu: true,
        component: './MenuRedirect',
      },

      {
        path: '/usage-record/fine-tune-computing',
        code: 'UsageRecord-FineTuneComputing',
        name: '训练算力用量',
        icon: <ExperimentOutlined />,
        component: './UsageRecord/FineTuneComputing',
      },
      {
        path: '/usage-record/storage-capacity',
        code: 'UsageRecord-StorageCapacity',
        name: '存储用量',
        icon: <DatabaseOutlined />,
        component: './UsageRecord/StorageCapacity',
      },
    ],
  };
